import { createBrowserRouter } from 'react-router-dom';
import Dashboard from './layout/Dashboard';
import About from './layout/About';
import App from './App';
import LiquidInstances from './layout/LiquidInstances';
import Learn from './layout/Learn';
const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: 'learn',
        element: <Learn />
      },
      {
        path: 'dashboard',
        element: <Dashboard />
      },
      {
        path: 'about',
        element: <About />
      },
      {
        index: true,
        path: 'liquid-instances/:id?',
        element: <LiquidInstances />
      }
    ]
  }
]);

export default router;
